module.exports = "<div>\n  <security-password v-if=\"!socialUser\" />\n  <mfa v-if=\"!socialUser\" />\n  <security-devices />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/admin/account/security/template.html
// module id = cTTp
// module chunks = 0